// test1122
(1122 && 0);
